export default __webpack_public_path__ + "static/media/wx.85d33dc9.svg";